/**
 * The Home container
 */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Container, Row, Col } from "reactstrap";

// import {setLanguage} from "redux-i18n";
import Page from "../../components/Page";
import Perks from "../../components/Perks";
import { listTaxons } from "../../redux/shop/taxons";
import { useSsrEffect } from "@issr/core";

import ShopTaxonCard from "../../components/ShopTaxonCard";

/**
 * Home container used as app default landing page
 */
const Shop = (props, context) => {
  const dispatch = useDispatch();
  const { language, taxons } = useSelector((state) => ({
    taxons: state.shopTaxons.list,
    language: state.i18nState.lang,
  }));

  /** frontload async calls */
  const frontload = async () => {
    dispatch(listTaxons({ taxonomyIds: 9, taxonomyFilter: "taxonomy_id" }));
  };

  useSsrEffect(frontload, [listTaxons, language]);
  return (
    <Page
      id="shop"
      pageType="shop"
      title={context.t(
        "Adhesive Film, Car Decals, Shop Window Letterings & customized Prints"
      )}
      lang={language}
      description={context.t(
        "Select from our range of ready designs and we produce them just for you!"
      )}
      image="https://cdn.myfolie.de/media/banner/800x500.png"
    >
      <Container className="my-2 text-center">
        <h1 className="h3">
          {context.t(
            "Adhesive Film, Car Decals, Shop Window Letterings & customized Prints"
          )}
        </h1>
        <p>
          {context.t(
            "Select from our range of ready designs and we produce them just for you!"
          )}
        </p>
      </Container>

      <Container className="my-2">
        <Row>
          {taxons?.data
            ?.filter(
              (obj) =>
                obj.relationships.taxonomy.data.id === "9" &&
                !obj.attributes.is_root &&
                !obj.attributes.hide_from_category_page &&
                obj.attributes.depth === 1
            )
            .sort((a, b) => a.attributes.position - b.attributes.position)
            .map((childTax, index) => (
              <Col
                key={`taxon-${index}`}
                xl={index < 2 ? 6 : 3}
                lg={index < 2 ? 6 : 4}
                xs={6}
                className="mb-3"
              >
                {index < 2 ? (
                  <Container>
                    <ShopTaxonCard taxonId={childTax?.id} titleTag="h2" wide />
                  </Container>
                ) : (
                  <ShopTaxonCard taxonId={childTax?.id} titleTag="h2" />
                )}
              </Col>
            ))}
        </Row>
      </Container>

      <Perks />
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
Shop.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default Shop;
